import {StatusAtendimento} from "../../../core/enums/status-atendimento";
import {StatusProcesso} from "../../../core/enums/status-processo";

export class DashboardAdvogado {
  totalProcessos: number;
  totalTarefas: number;
  totalTarefasAndamento: number;
  totalAtendimentosHoje: number;

  processos: ProcessoDashboard[] = [];
  audiencias: AudienciaDashboard[] = [];
  atendimentos: AtendimentoDashboard[] = [];
  tarefas: TarefaDashboard[] = [];
}

export class ProcessoDashboard {
  id: number;
  titulo: string;
  cliente: string;
  ultimaMovimentacao: Date;
  status: StatusProcesso;
}

export class AtendimentoDashboard {
  id: number;
  cliente: string;
  status: StatusAtendimento;
  data: Date;
  titulo: string;
  descricao: string;
}

export class AudienciaDashboard {
  id: number;
  caso: string;
  data: Date;
}

export class TarefaDashboard {
  id: number;
  descricao: string;
  tipo: string;
  dataEntrega: Date;
  status: number;
}
